// src/components/block/liveStreamManagment/MediaboardVideo.tsx
//
// <video> du mediaboard : même props qu'un <video>, mais la source passe par
// setVideoSource — un fichier local (blob:/data:) comme une vidéo HLS du compte.

import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { setVideoSource, releaseVideoSource } from '../../../dataTypes/liveStreamManagment/utils_videoSource';

type Props = Omit<React.VideoHTMLAttributes<HTMLVideoElement>, 'src'> & { src: string };

export const MediaboardVideo = forwardRef<HTMLVideoElement, Props>(({ src, ...rest }, outerRef) => {
  const ref = useRef<HTMLVideoElement>(null);
  useImperativeHandle(outerRef, () => ref.current as HTMLVideoElement);

  useEffect(() => {
    const v = ref.current;
    if (!v || !src) return;
    setVideoSource(v, src);
    return () => releaseVideoSource(v);
  }, [src]);

  return <video ref={ref} {...rest} />;
});

MediaboardVideo.displayName = 'MediaboardVideo';
